import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import App, { CountryContext } from 'Containers/App';
import Homepage from 'Screens/Homepage';
import GradeLandingPage from 'Screens/GradeLandingPage';
import MathLandingPage from 'Screens/MathLandingPage';
import MediaLandingPage from 'Screens/MediaLandingPage';
import GamePage from 'Screens/GamePage';
import BookPage from 'Screens/BookPage';
import VideoPage from 'Screens/VideoPage';
import TeachersLandingPage from 'Screens/TeachersLanding';
import TextPage from 'Screens/TextPage';
import ErrorPage from 'Screens/ErrorPage';
import VideoSeries from 'Containers/VideoSeries';
import SchoolsDemoPage from 'Screens/SchoolsDemoPage';
import HarryMoonLandingPage from 'Screens/HarryMoonLandingPage';
import MonsterMeLandingPage from 'Screens/MonsterMeLandingPage';
import SearchPage from 'Screens/SearchPage';

import { TINYBOP_EMBEDDED_GAMES } from 'Constants/tinybopEmbeddedGames';

const tbSchoolsDemoPath = '/games/tinybop-schools-demo';
  

export const AppRoutes = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<App />}>
          <Route index element={<Homepage />} />
          <Route
            path="grade/:grade"
            element={<GradeLandingPage />}
          />
          <Route
            path="pre-k-and-k-playground"
            element={<GradeLandingPage />}
          />
          {/* TODO: remove */}
          <Route
            path="test-sub1stgrade-tag"
            element={<GradeLandingPage />}
          />
          <Route path="playground" element={<Navigate to="pre-k-and-k-playground" />} />
          <Route
            path="games"
            element={<MediaLandingPage />}
          />
          <Route
            path={tbSchoolsDemoPath}
            element={<SchoolsDemoPage />}
          />
          {/* Routes and redirects for rotatin tinybop embedded game */}
          {Object.keys(TINYBOP_EMBEDDED_GAMES).map(key => {
            const { slug } = TINYBOP_EMBEDDED_GAMES[key];
            const path = `games/tinybop-schools-${slug}`;
            return <Route key={key} path={path} element={<Navigate to={tbSchoolsDemoPath} />} />;
          })}

          <Route
            path="games/:gameID"
            element={<GamePage />}
          />
          <Route
            path="/videos"
            element={<MediaLandingPage />}
          />
          <Route
            path="/videos/:seriesID"
            element={<VideoSeries />}
          />
          <Route
            path="/videos/:seriesID/:videoID"
            element={<VideoPage />}
          />
          <Route
            path="math-zone"
            element={<MathLandingPage />}
          />
          <Route
            path="/books"
            element={<MediaLandingPage />}
          />
          <Route
            path="/books/:bookID"
            element={<Navigate to="page/1" />}
          />
          <Route
            path="/books/:bookID/page"
            element={<Navigate to="page/1" />}
          />
          <Route
            path="/books/:bookID/page/:pageID"
            element={(
              <CountryContext.Consumer>
                {countryCode => <BookPage countryCode={countryCode} />}
              </CountryContext.Consumer>
                  )}
          />
          <Route
            path="harry-moon"
            element={<HarryMoonLandingPage />}
          />
          <Route
            path="monster-me"
            element={<MonsterMeLandingPage />}
          />
          <Route
            path="teachers-and-parents"
            element={<TeachersLandingPage />}
          />
          <Route
            path="advertise-with-funbrain"
            element={<TextPage />}
          />
          <Route 
            path="parents-and-teachers" 
            element={<Navigate to="/teachers-and-parents" />} 
          />
          <Route
            path="about"
            element={<TextPage />}
          />
          <Route
            path="privacy-policy"
            element={<TextPage />}
          />
          <Route 
            path="search"
            element={<SearchPage />} 
          />
          <Route 
            path="terms-of-use"
            element={<TextPage />}
          />
          <Route
            path="error/page-not-found"
            errorElement={<ErrorPage />}
          />
          <Route
            path="error/forbidden"
            errorElement={<ErrorPage />}
          />
          <Route
            path="*"
            errorElement={<ErrorPage />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  )
};
